import React from 'react';
import { Check } from 'lucide-react';

import { ctw } from '@/common';
import { WarningFilledSvg } from '@/components/atoms';
import { riskTypeMapper } from '../constants';

type RiskTypesDisplayProps = {
  riskTypes: Record<string, { status: 'clear' | 'alert' } | null> | null | undefined;
  allowedKeys?: Array<keyof typeof riskTypeMapper>;
};

export const RiskTypesDisplay: React.FC<RiskTypesDisplayProps> = ({ riskTypes, allowedKeys }) => {
  if (!riskTypes) {
    return null;
  }

  const keysToShow =
    allowedKeys ?? (Object.keys(riskTypeMapper) as Array<keyof typeof riskTypeMapper>);

  return (
    <div className="space-y-2">
      {keysToShow.map(name => {
        if (!riskTypes[name]) {
          return null;
        }

        const { status } = riskTypes[name];
        const { Icon, title } = riskTypeMapper[name];

        return (
          <div key={name} className="flex items-center gap-2">
            {status === 'clear' ? (
              <div className="flex h-5 w-5 items-center justify-center rounded-full bg-green-500/10">
                <Check className="h-2.5 w-2.5 text-green-500" strokeWidth={6} />
              </div>
            ) : (
              <div className="flex h-5 w-5 items-center justify-center">
                <WarningFilledSvg className="h-6 w-6" />
              </div>
            )}

            <div
              className={ctw(
                'flex items-center gap-2 text-sm',
                status === 'clear' ? 'text-stone-400' : 'text-slate-900',
              )}
            >
              <Icon className="h-4 w-4" strokeWidth={1} />
              <span>{title}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
